import { type Action, combineReducers, configureStore, type ThunkAction } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { authReducer } from './auth';
import { dashboardReducer } from './dashboard';
import { personnelReducer } from './personnel';
import { teamsReducer } from './teams';
import { assessmentsApi } from '@/services/assessmentsApi';
import { authApi } from '@/services/authApi';
import { incidentsApi } from '@/services/incidentsApi';
import { palmettoGroupApi } from '@/services/palmettoGroupApi';
import { personnelApi } from '@/services/personnelApi';
import { photosApi } from '@/services/photosApi';
import { settingsApi } from '@/services/settingsApi';
import { teamsApi } from '@/services/teamsApi';

const NODE_ENV = import.meta.env.MODE;

const rootReducer = combineReducers({
  auth: authReducer,
  dashboard: dashboardReducer,
  personnel: personnelReducer,
  teams: teamsReducer,
  // RTK Query reducers
  [assessmentsApi.reducerPath]: assessmentsApi.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [incidentsApi.reducerPath]: incidentsApi.reducer,
  [palmettoGroupApi.reducerPath]: palmettoGroupApi.reducer,
  [personnelApi.reducerPath]: personnelApi.reducer,
  [photosApi.reducerPath]: photosApi.reducer,
  [settingsApi.reducerPath]: settingsApi.reducer,
  [teamsApi.reducerPath]: teamsApi.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  devTools: NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      assessmentsApi.middleware,
      authApi.middleware,
      incidentsApi.middleware,
      palmettoGroupApi.middleware,
      personnelApi.middleware,
      photosApi.middleware,
      settingsApi.middleware,
      teamsApi.middleware
    ),
});

setupListeners(store.dispatch);
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action>;
